import { render, staticRenderFns } from "./DocumentosCartoes.vue?vue&type=template&id=0084a400&scoped=true"
import script from "./DocumentosCartoes.vue?vue&type=script&lang=js"
export * from "./DocumentosCartoes.vue?vue&type=script&lang=js"
import style0 from "./DocumentosCartoes.vue?vue&type=style&index=0&id=0084a400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084a400",
  null
  
)

export default component.exports